module.exports = __webpack_public_path__ + "img/tn-timeline-main-6.b03712d8.jpg";